import { Href } from "expo-router";
import { createWithEqualityFn } from "zustand/traditional";

type LandingStore = {
  deepLink?: Href;
  queuedDeepLink?: Href;
  /** Unlock code extracted from a deep link's ?unlockCode query param */
  unlockCode?: string;
  restart: () => void;
};

export const useLandingStore = createWithEqualityFn<LandingStore>()(
  (set) => ({
    deepLink: undefined,
    queuedDeepLink: undefined,
    unlockCode: undefined,
    restart: () => {
      set({ deepLink: undefined, queuedDeepLink: undefined, unlockCode: undefined });
    },
  }),
);
